import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/movimentacao-vaga`;

export const buscarHistorico = (idVaga) => {
	return api.get(BASE_URL, { params: { idVaga } });
};

export const buscarAnexoHistorico = (id) => {
	return api.get(`${BASE_URL}/${id}/base64-anexo`);
};

export const salvarMovimentacao = (movimentacao) => {
	return api.post(BASE_URL, movimentacao);
}
